export default __webpack_public_path__ + "static/media/mangoerp.004ee887.png";